function Switch() {
  return (
    <div className="dice-face face--switch">
      <span>SWITCH</span>
    </div>
  );
}

export default Switch;
